import { useQueryClient } from 'react-query';

import {
  venueLeadsApiKeys,
  useVenueLeadsApi,
} from '../../../../hooks/api/venue-leads/useVenueLeadsApi';
import { useSearchApi } from '../../../../hooks/api/useSearchApi';
import type { SearchApiOptions } from '../../../../types/api';
import type {
  VenueLeadSearchFacetFields,
  VenueLeadSearchItem,
  VenueLeadSearchParams,
  VenueLeadSearchResults,
} from '../../../../types/events/venue-leads';

export function useSearchVenueLeads(
  organizationId: string,
  params: Partial<VenueLeadSearchParams>,
  {
    enabled = true,
    ...options
  }: Omit<
    Partial<
      SearchApiOptions<
        VenueLeadSearchItem,
        VenueLeadSearchFacetFields,
        VenueLeadSearchResults
      >
    >,
    'page' | 'queryKey' | 'request'
  > = {}
) {
  const queryClient = useQueryClient();
  const api = useVenueLeadsApi();
  const result = useSearchApi<
    VenueLeadSearchItem,
    VenueLeadSearchFacetFields,
    VenueLeadSearchResults
  >({
    enabled: !!organizationId && enabled,
    queryKey: venueLeadsApiKeys.search(organizationId, params),
    request: () => api.search(organizationId, params),
    ...options,
  });
  return {
    ...result,
    invalidate: () =>
      queryClient.invalidateQueries(
        venueLeadsApiKeys.search(organizationId, params)
      ),
  };
}
